export const DocumentStatusEnum = Object.freeze({
    PENDING: "pending",
    REJECTED: "rejected",
    VALIDATING: "validating",
    COMPLETED: "completed",
});

export default DocumentStatusEnum;